import {
	NEW_LOGIN_SUCCESS,
	NEW_LOGIN_ERROR,
	NEW_LOGIN_START,
	NEW_LOGIN_PROFILE_PIC,
	CLEAR_ADMIN_PREVIOUS_REDUCER,
} from "../Constants/LoginConstatnt";

const initialState = {
	loading: false,
	data: null,
	profilePic: "",
};

export default function LoginReducer(state = { ...initialState }, action) {
	switch (action.type) {
		case NEW_LOGIN_START:
			return {
				...state,
				loading: true,
			};
		case NEW_LOGIN_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
			};
		case NEW_LOGIN_PROFILE_PIC:
			return {
				...state,
				profilePic: action.payload,
				loading: false,
			};
		case NEW_LOGIN_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};

		case CLEAR_ADMIN_PREVIOUS_REDUCER:
			return {
				...state,
				loading: false,
				data: null,
			};

		default:
			return state;
	}
}
